var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "tile is-ancestor is-parent" }, [
    _c("div", { staticClass: "tile is-parent is-8" }, [
      _c("article", { staticClass: "tile is-child box" }, [
        _c("p", { staticClass: "title" }, [_vm._v("Detail Info")]),
        _c("div", { staticClass: "field" }, [
          _c("label", { staticClass: "label" }, [_vm._v("Remark Description")]),
          _c("p", { staticClass: "control" }, [
            _c("textarea", {
              directives: [
                { name: "focus-inserted", rawName: "v-focus-inserted" },
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.value.remark,
                  expression: "value.remark",
                },
              ],
              staticClass: "textarea",
              class: {
                "is-danger": _vm.$v.entity.remark.$error,
                "is-warning": _vm.remarkExists,
              },
              domProps: { value: _vm.value.remark },
              on: {
                input: [
                  function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.value, "remark", $event.target.value)
                  },
                  function ($event) {
                    _vm.$v.entity.remark.$touch()
                    _vm.checkRemarkExists()
                  },
                ],
              },
            }),
          ]),
          _vm.$v.entity && !_vm.$v.entity.remark.required
            ? _c("span", { staticClass: "help is-danger" }, [
                _vm._v("Remark Description is required."),
              ])
            : _vm._e(),
          _vm.remarkExists
            ? _c("span", { staticClass: "help is-warning" }, [
                _vm._v("Remark Description already exists. "),
              ])
            : _vm._e(),
        ]),
        _c("div", { staticClass: "is-divider" }),
        _c("div", { staticClass: "field" }, [
          _c("div", { staticClass: "buttons has-addons is-centered" }, [
            _c(
              "span",
              {
                staticClass: "button",
                class: { "is-success is-selected": _vm.value.isActive },
                on: {
                  click: function ($event) {
                    return _vm.toggleActive(true)
                  },
                },
              },
              [_vm._m(0), _c("span", [_vm._v("Active")])]
            ),
            _c(
              "span",
              {
                staticClass: "button",
                class: { "is-danger is-selected": !_vm.value.isActive },
                on: {
                  click: function ($event) {
                    return _vm.toggleActive(false)
                  },
                },
              },
              [_vm._m(1), _c("span", [_vm._v("In-Active")])]
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "mdi mdi-check" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "mdi mdi-close" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }